import React, { useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// css
import { OverlayFullScreen } from "../../../TransactionHistory/TransHistoryItem/PopupShowMedia/index.styles";
import { WrapComfirmReject } from "./index.styles";

// component
import Button from "../../../../../../Control/Button";

// image
import IcConfirm from "../../../../../../../assets/images/IcConfirm";
import IcClose from "../../../../../../../assets/images/IcClose";

// redux
import { apiGetRejectUser } from "../../../../../../../redux/censorship/detailCensorship/action";
import { updateWaitingCondsFilter } from "../../../../../../../redux/censorship/listWaitingCensorship/action";

// constant
import * as path from "../../../../../../../constant/path";
import { useOnClickOutside } from "../../../../../../../hook/useClickOutside";

const PopupConfirmRejectCensor = ({ onClickClosePopup, payload }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const refPopup = useRef();

  const { user, condFilters, list } = useSelector((state) => ({
    user: state.censorshipReducer.detailCensorshipReducer.details.user,
    condFilters:
      state.censorshipReducer.listWaitingCensorshipReducer.condFilters,
    list: state.censorshipReducer.listWaitingCensorshipReducer.list,
  }));

  const callbackSuccess = () => {
    const callbackUpdateCondFiltersSuccess = () => {
      history.push(
        `/${path.MAIN}/${path.CENSORSHIP}/${path.WAITING_CENSORSHIP}`
      );
    };
    // set filter
    dispatch(
      updateWaitingCondsFilter({
        condFilters: {
          ...condFilters,
          lastItem: "",
          limit: list.length === 0 ? 15 : list.length,
        },
        callbackSuccess: callbackUpdateCondFiltersSuccess,
      })
    );
  };

  const callbackError = () => {};

  const _handleSubmit = () => {
    dispatch(
      apiGetRejectUser(
        {
          uid: payload.uid,
          reasons: payload.reasons,
          optionalReason: payload.optionalReason,
        },
        callbackSuccess,
        callbackError
      )
    );

    onClickClosePopup();
  };

  useOnClickOutside(refPopup, () => onClickClosePopup());
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      onClickClosePopup();
    }
  });

  return (
    <OverlayFullScreen>
      <WrapComfirmReject ref={refPopup}>
        <div className="title">
          <div className="comfirm-title">Xác nhận từ chối</div>
          <div className="icon-close" onClick={onClickClosePopup}>
            <IcClose />
          </div>
        </div>

        <div className="confirm-value">
          Bạn vui lòng xác nhận từ chối hồ sơ: <span>{user?.fullName}</span>
        </div>
        <div className="confirm">
          <div className="notify">*</div>
          <p>Thông tin phê duyệt sẽ không thể chỉnh sửa</p>
        </div>
        <Button
          iconBtn={<IcConfirm />}
          type="submit"
          text="Xác nhận"
          className="btn-confirm"
          onClick={_handleSubmit}
        />
        <Button
          type="submit"
          text="Cancel"
          className="btn-cancel"
          onClick={onClickClosePopup}
        />
      </WrapComfirmReject>
    </OverlayFullScreen>
  );
};

export default PopupConfirmRejectCensor;
